<div *ngIf="isLoading" class="loader-overlay">
  <cm-loader></cm-loader>
</div>
<div class="page hidden" [ngClass]="{ hidden: isLoading }">
  <div class="header">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill-rule="evenodd"
        d="M10.110775,0.0001025 L10.1962,0.00146 C10.4789,0.0069 10.7587,0.02407 11.0352,0.0525 C11.2515,0.07475 11.4226,0.24185 11.4596,0.45613 L11.4596,0.45613 L11.7329,2.0413 C11.7672,2.24039 11.9184,2.39781 12.1133,2.45088 C12.7291,2.61852 13.3148,2.85909 13.8606,3.16273 C14.0351,3.25982 14.2504,3.25409 14.4136,3.13892 L14.4136,3.13892 L15.7159,2.21964 C15.8934,2.0943 16.1325,2.09706 16.3012,2.23411 C16.8383,2.67046 17.3292,3.16141 17.7655,3.69851 C17.9026,3.8672 17.9053,4.10621 17.78,4.28378 L17.78,4.28378 L16.8808,5.55766 C16.7639,5.7232 16.7599,5.94217 16.8611,6.11771 C17.1814,6.67321 17.4358,7.27153 17.6136,7.90197 C17.668,8.09477 17.8246,8.24377 18.0219,8.27777 L18.0219,8.27777 L19.5435,8.54007 C19.7578,8.57707 19.9249,8.74807 19.9471,8.96437 C19.9718,9.20307 19.9877,9.44227 19.9951,9.68177 C19.9984,9.78727 20,9.89327 20,9.99957 C20,10.08487 19.999,10.16997 19.9968,10.25487 L19.9968,10.25487 L19.9948,10.32597 C19.9872,10.56447 19.9712,10.80077 19.9471,11.03477 C19.9249,11.25107 19.7578,11.42207 19.5435,11.45907 L19.5435,11.45907 L18.0461,11.71717 C17.845,11.75327 17.6888,11.90427 17.6363,12.09857 C17.4622,12.74287 17.2083,13.35437 16.8859,13.92187 C16.7864,14.09697 16.7911,14.31447 16.9073,14.47897 L16.9073,14.47897 L17.78,15.71537 C17.9053,15.89297 17.9026,16.13197 17.7655,16.30067 C17.3292,16.83777 16.8382,17.32867 16.3012,17.76507 C16.1325,17.90207 15.8934,17.90487 15.7159,17.77947 L15.7159,17.77947 L14.4717,16.90137 C14.3081,16.79047 14.0947,16.78737 13.9224,16.88537 C13.3549,17.20777 12.7434,17.46167 12.0991,17.63577 C11.9038,17.68857 11.7521,17.84617 11.7177,18.04557 L11.7177,18.04557 L11.4596,19.54297 C11.4226,19.75727 11.2515,19.92437 11.0352,19.94667 C10.3469,20.01787 9.6533,20.01787 8.9649,19.94667 C8.7486,19.92437 8.5776,19.75727 8.5406,19.54307 L8.5406,19.54307 L8.2763,18.01067 C8.2388,17.81837 8.0918,17.66647 7.90248,17.61307 C7.58827,17.52447 7.28203,17.41687 6.9851,17.29147 C6.68325,17.16927 6.38745,17.02757 6.09964,16.86637 C5.92676,16.76957 5.71346,16.77377 5.55047,16.88577 L5.55047,16.88577 L4.28424,17.77957 C4.10667,17.90487 3.86766,17.90207 3.69897,17.76507 C3.48787,17.59357 3.2839,17.41367 3.08757,17.22577 C3.03424,17.17477 2.98135,17.12307 2.92893,17.07067 L2.92893,17.07067 L2.76275,16.90047 C2.57895,16.70777 2.40278,16.50767 2.2347,16.30087 C2.09748,16.13217 2.09436,15.89347 2.21976,15.71577 L2.21976,15.71577 L3.096,14.47447 C3.21271,14.30907 3.21692,14.09047 3.1161,13.91497 C2.78364,13.33627 2.53078,12.72437 2.35753,12.09507 C2.30406,11.90087 2.14691,11.75047 1.94841,11.71627 L1.94841,11.71627 L0.45705,11.45917 C0.24287,11.42227 0.07581,11.25127 0.05343,11.03507 C-0.01781,10.34677 -0.01781,9.65247 0.05343,8.96407 C0.0758,8.74797 0.24286,8.57697 0.45705,8.54007 L0.45705,8.54007 L1.94841,8.28287 C2.14691,8.24867 2.30406,8.09827 2.35753,7.90409 C2.53078,7.27483 2.78364,6.66291 3.1161,6.08424 C3.21692,5.90875 3.21271,5.69009 3.096,5.52474 L3.096,5.52474 L2.21973,4.28337 C2.09434,4.10573 2.09745,3.86702 2.23467,3.69834 C2.40276,3.49145 2.57895,3.2914 2.76276,3.09869 L2.76276,3.09869 L2.92893,2.9285 C2.98135,2.87609 3.03423,2.82438 3.08755,2.77338 C3.28389,2.58552 3.48786,2.40557 3.69897,2.23407 C3.86766,2.09702 4.10667,2.09427 4.28424,2.21961 L4.28424,2.21961 L5.55312,3.11529 C5.71576,3.22544 5.92769,3.22911 6.09964,3.13281 C6.67113,2.81273 7.27409,2.56955 7.89339,2.40325 C8.0891,2.3507 8.241,2.19298 8.2755,1.99329 L8.2755,1.99329 L8.5406,0.45612 C8.5776,0.24184 8.7486,0.07474 8.9649,0.05249 C9.2781,0.02007 9.5922,0.00285 9.9067,-5.10702591e-14 L9.9067,-5.10702591e-14 L10.110775,0.0001025 L10.110775,0.0001025 Z M10,3.99957 C6.68629,3.99957 4,6.68586 4,9.99957 C4,13.31327 6.68629,15.99957 10,15.99957 C13.3137,15.99957 16,13.31327 16,9.99957 C16,6.68586 13.3137,3.99957 10,3.99957 Z M8,7.13461 C8,6.28677 8.9889,5.82362 9.6402,6.36639 L9.6402,6.36639 L13.0781,9.23137 C13.5579,9.63117 13.5579,10.36797 13.0781,10.76777 L13.0781,10.76777 L9.6402,13.63277 C8.9889,14.17557 8,13.71237 8,12.86457 L8,12.86457 Z"
      />
    </svg>
    <div class="name">
      <div class="label">{{ this.modelName }}</div>
      <cm-dropdown
        [options]="moreDropdownOptions"
        [trigger]="moreDropdownTrigger"
      >
      </cm-dropdown>
    </div>

    <div class="buttons">
      <input
        hidden
        (change)="onFileSelected()"
        #fileInput
        type="file"
        id="file"
        accept=".bpmn"
      />

      <cm-dropdown
        title="Execute"
        [options]="deploymentDropdownOptions"
        [trigger]="deploymentDropdownTrigger"
        *ngIf="vvs.visibilities.modeler.start.visible"
      >
      </cm-dropdown>

      <cm-button
        (cmPress)="saveModel({ confirmation: true })"
        label="Save"
        [disabled]="vvs.visibilities.modeler.save.disabled"
        appearance="secondary"
        *ngIf="vvs.visibilities.modeler.save.visible"
      ></cm-button>
    </div>

    <div *ngIf="template || parentTemplate" style="position: relative">
      <cm-toggle
        (cmInput)="toggleTemplateGuide($event)"
        [attr.checked]="templateGuide"
        label="Template Guide"
        slot="right"
        class="template-guide-toggle"
      ></cm-toggle>
      <div
        class="template-guide"
        *ngIf="templateGuide && showTemplateGuide"
        style="top: 35px; right: 50px"
      >
        <div class="headline">Template Guide</div>
        <div class="text">
          Hey! We added some guides to your Diagram to explain the important
          elements. Click on any of the highlighted areas to learn more.
        </div>
        <cm-button
          label="Let’s start"
          appearance="secondary"
          size="small"
          (cmPress)="templateGuideDismiss()"
        ></cm-button>
      </div>
      <div class="header-vertical-divider narrow" slot="right"></div>
    </div>
  </div>

  <div
    class="modeler"
    [ngClass]="{ 'modeler-reduced-height': isExpiredTrial() }"
  >
    <div id="canvas" style="flex-grow: 10; height: 100%"></div>
    <div
      id="properties-wrapper"
      [ngClass]="{ invisible: propertiesPanelHidden }"
    >
      <div id="properties-toggle" (click)="togglePropertyPanel()">
        <div>Properties Panel</div>
      </div>
      <div id="properties"></div>
    </div>
  </div>
</div>

<cm-modal
  #deployModal
  headline="Save and Deploy Diagram"
  cancelLabel="Cancel"
  confirmLabel="{{
    clusters && clusters.length > 0 ? 'Deploy' : 'Create Cluster'
  }}"
  [confirmDisabled]="
    (clusters && clusters.length > 0 && !allowDeploy) ||
    (!(clusters && clusters.length > 0) && clusterCreationDisabled) ||
    hasGeneralLintErrors
  "
>
  <cm-banner *ngIf="clusters.length === 0" appearance="warning">
    <cm-text>
      Unfortunately, you have no Clusters to deploy to. Please create a Cluster.
    </cm-text>
  </cm-banner>
  <cm-banner
    *ngIf="hasGeneralLintErrors && clusters.length > 0"
    appearance="error"
  >
    <cm-text>
      Unfortunately, your Diagram has Errors and can't be deployed on any
      cluster.
    </cm-text>
  </cm-banner>
  <cm-banner
    *ngIf="!hasGeneralLintErrors && selectedClusterHasLintErrors"
    appearance="warning"
  >
    <cm-text>
      The diagram contains elements which are not supported by the Zeebe
      generation of the selected cluster. To execute, select a cluster with a
      Zeebe generation {{ lowestSupportedZeebeVersion }} or above.
    </cm-text>
  </cm-banner>
  <cm-loader *ngIf="waitingForClusters"></cm-loader>
  <cm-form>
    <ng-container *ngIf="clusters && clusters.length > 0">
      <cm-form-group label="Select Cluster">
        <cm-text>Your Diagram will be executed in Cluster:</cm-text>
      </cm-form-group>
      <cm-radiobutton-group
        [value]="selectedClusterUuid"
        formName="selectedClusterUuid"
      >
        <div *ngFor="let cluster of clusters; let i = index">
          <cm-radiobutton
            [value]="cluster.uuid"
            [label]="cluster.name"
            [helperText]="cluster.uuid"
            [disabled]="isUnsupportedAlpha(cluster) || lintReports[i]"
            (cmSelected)="recalcAllowDeploy(cluster)"
          ></cm-radiobutton>
          <div class="status">
            <span
              *ngIf="cluster.status.ready === 'Healthy'"
              class="cluster-state ready"
            ></span>
            <span
              *ngIf="
                cluster.status.ready !== 'Creating' &&
                cluster.status.ready !== 'Healthy'
              "
              class="cluster-state not-ready"
            ></span>
            <span
              *ngIf="cluster.status.ready === 'Creating'"
              class="cluster-state creating"
            ></span>
            <cm-text>{{ cluster.status.ready }}</cm-text>
          </div>
        </div>
      </cm-radiobutton-group>
    </ng-container>
    <cm-text *ngIf="getHealthyClusters().length === 0">
      Please wait until at least one Cluster is healthy.
    </cm-text>
  </cm-form>
</cm-modal>

<cm-modal
  #executeModal
  headline="Execute Diagram"
  cancelLabel="Cancel"
  confirmLabel="{{
    clusters && clusters.length === 0 && !clusterCreationDisabled
      ? 'Create Cluster'
      : 'Execute'
  }}"
  position="top"
  [confirmDisabled]="
    (clusters && clusters.length > 0 && !allowDeploy) ||
    (!(clusters && clusters.length > 0) && clusterCreationDisabled) ||
    hasGeneralLintErrors
  "
>
  <cm-banner *ngIf="clusters.length === 0" appearance="warning">
    <cm-text>
      Unfortunately, you have no Clusters to deploy to. Please create a Cluster.
    </cm-text>
  </cm-banner>
  <cm-banner
    *ngIf="hasGeneralLintErrors && clusters.length > 0"
    appearance="error"
  >
    <cm-text>
      Unfortunately, your Diagram has Errors and can't be deployed on any
      cluster.
    </cm-text>
  </cm-banner>
  <cm-banner
    *ngIf="!hasGeneralLintErrors && selectedClusterHasLintErrors"
    appearance="warning"
  >
    <cm-text>
      The diagram contains elements which are not supported by the Zeebe
      generation of the selected cluster. To execute, select a cluster with a
      Zeebe generation {{ lowestSupportedZeebeVersion }} or above.
    </cm-text>
  </cm-banner>
  <cm-loader *ngIf="waitingForClusters"></cm-loader>
  <cm-form>
    <ng-container *ngIf="clusters && clusters.length > 0">
      <cm-form-group label="Select Cluster">
        <cm-text>Your Diagram will be executed in Cluster:</cm-text>
      </cm-form-group>
      <cm-radiobutton-group
        [value]="selectedClusterUuid"
        formName="selectedClusterUuid"
      >
        <div *ngFor="let cluster of clusters; let i = index">
          <cm-radiobutton
            [value]="cluster.uuid"
            [label]="cluster.name"
            [helperText]="cluster.uuid"
            (cmSelected)="recalcAllowDeploy(cluster)"
          ></cm-radiobutton>
          <div class="status">
            <span
              *ngIf="cluster.status.ready === 'Healthy'"
              class="cluster-state ready"
            ></span>
            <span
              *ngIf="
                cluster.status.ready !== 'Creating' &&
                cluster.status.ready !== 'Healthy'
              "
              class="cluster-state not-ready"
            ></span>
            <span
              *ngIf="cluster.status.ready === 'Creating'"
              class="cluster-state creating"
            ></span>
            <cm-text>{{ cluster.status.ready }}</cm-text>
          </div>
        </div>
      </cm-radiobutton-group>

      <cm-text *ngIf="getHealthyClusters().length === 0">
        Please wait until at least one Cluster is healthy.
      </cm-text>
    </ng-container>
    <cm-form-group label="Add Variable (Optional)">
      <cm-text>
        Optionally specify data to add to the newly created Instance. Variables
        can be accessed inside the Process Instance. Read more about
        <cm-link
          href="https://docs.camunda.io/docs/product-manuals/concepts/variables"
          label="Variables"
        ></cm-link>
      </cm-text>

      <cm-textfield
        label="Variable"
        helperText='in JSON format e.g., {"orderNumber": "A12BH98", "date": "2020-10-15", "amount": 185.34}'
        type="multiline"
        showRequired
        formName="startInstanceMetadata"
        [validation]="isValidJson"
      ></cm-textfield>
    </cm-form-group>
  </cm-form>
</cm-modal>

<cm-modal #deployFailedModal headline="Deploy failed" confirmLabel="Ok">
  <cm-text>
    Deploy diagram on cluster {{ deployErrorOnClustername }} failed:
    <p>{{ deployErrorMessage }}</p>
  </cm-text>
</cm-modal>

<cm-modal #importFailedModal headline="Import failed" confirmLabel="Ok">
  <cm-text>Import failed, invalid BPMN!</cm-text>
</cm-modal>

<cm-modal
  #startInstanceModal
  headline="Start Instance"
  cancelLabel="Cancel"
  confirmLabel="Start Instance"
>
  <cm-form>
    <cm-text>
      Start an Instance on Cluster
      {{
        existingModel && existingModel.deployedOnCluster
          ? '"' + existingModel.deployedOnCluster.name + '"'
          : ''
      }}
    </cm-text>
    <cm-form-group label="Add Variable (Optional)">
      <cm-text>
        Optionally specify data to add to the newly created Instance. Variables
        can be accessed inside the Process Instance. Read more about
        <cm-link
          href="https://docs.camunda.io/docs/product-manuals/concepts/variables"
          label="Variables"
        ></cm-link>
      </cm-text>

      <cm-textfield
        label="Variable"
        helperText='in JSON format e.g., {"orderNumber": "A12BH98", "date": "2020-10-15", "amount": 185.34}'
        type="multiline"
        showRequired
        formName="startInstanceMetadata"
        [validation]="isValidJson"
      ></cm-textfield>
    </cm-form-group>
  </cm-form>
</cm-modal>

<cm-modal
  #startInstanceFailedModal
  headline="Start Instance failed"
  confirmLabel="Ok"
>
  <cm-text>
    Start Instance on cluster
    {{
      existingModel && existingModel.deployedOnCluster
        ? existingModel.deployedOnCluster.name
        : ''
    }}
    failed:
    <p>{{ startInstanceErrorMessage }}</p>
  </cm-text>
</cm-modal>

<cm-modal
  #deleteModal
  headline="Delete Diagram"
  cancelLabel="Cancel"
  confirmLabel="Delete"
  confirmAppearance="danger"
>
  <cm-text>
    Are you sure you want to delete
    <cm-text appearance="emphasis">
      "{{ existingModel ? existingModel.name : '' }}"
    </cm-text>
    ?
  </cm-text>
</cm-modal>

<cm-modal #invalidFormatModal headline="Invalid BPMN Format" confirmLabel="Ok">
  <cm-text>The uploaded BPMN file contains a wrong format.</cm-text>
  <cm-text>Only Zeebe BPMN files can be used.</cm-text>
</cm-modal>

<cm-modal
  #renameModal
  headline="Rename Diagram"
  cancelLabel="Cancel"
  confirmLabel="Rename"
>
  <cm-form>
    <cm-textfield
      label="Current Name"
      disabled
      [value]="modelName"
    ></cm-textfield>
    <cm-textfield
      label="New Name"
      maxlength="50"
      formName="newName"
      [fieldSuffix]="{ type: 'maxlength' }"
    ></cm-textfield>
  </cm-form>
</cm-modal>

<create-cluster-dialog></create-cluster-dialog>
